export default __webpack_public_path__ + "static/media/caution_icon.b7f1fb7e.svg";